import { createFileRoute } from '@tanstack/react-router';
import Growth from 'src/pages/Organization/Reports/Growth';

export const Route = createFileRoute('/$organizationSlug/reports/growth/')({
  component: Growth,
});
